export default {
  // Navigation
  nav_home: 'होम',
  nav_dashboard: 'डैशबोर्ड',
  nav_orders: 'ऑर्डर',
  nav_wallet: 'वॉलेट',
  nav_analytics: 'एनालिटिक्स',
  nav_referral: 'रेफरल',
  nav_account: 'खाता',
  nav_notifications: 'सूचनाएं',
  nav_logout: 'लॉगआउट',
  nav_login: 'लॉगिन',
  nav_signup: 'साइन अप',
  nav_deposit_requests: 'जमा अनुरोध',
  nav_withdraw_requests: 'निकासी अनुरोध',
  nav_support_ticket: 'सपोर्ट टिकट',
  nav_system_logs: 'सिस्टम लॉग',
  nav_announcements: 'घोषणाएं',
  nav_activity_logs: 'गतिविधि लॉग',
  nav_settings: 'सेटिंग्स',
  nav_section_main: 'मुख्य',
  nav_user_active: 'अभी सक्रिय',
  nav_more: 'अधिक',
  nav_logout_confirm: 'क्या आप वाकई लॉगआउट करना चाहते हैं?',
  nav_language: 'भाषा',

  // Dashboard
  dashboard_welcome: 'वापसी पर स्वागत है',
  dashboard_total_earnings: 'कुल कमाई',
  dashboard_pending_orders: 'लंबित ऑर्डर',
  dashboard_completed_orders: 'पूरे हुए ऑर्डर',
  dashboard_commission_rate: 'कमीशन दर',
  dashboard_quick_actions: 'त्वरित कार्रवाई',
  dashboard_recent_orders: 'हाल के ऑर्डर',
  dashboard_recent_activity: 'हाल की गतिविधि',
  dashboard_wallet_balance: 'वॉलेट बैलेंस',
  dashboard_deposit: 'जमा करें',
  dashboard_withdraw: 'निकासी',
  dashboard_view_all: 'सभी देखें',
  greeting_morning: 'शुभ प्रभात',
  greeting_afternoon: 'शुभ दोपहर',
  greeting_evening: 'शुभ संध्या',
  dashboard_greeting_desc: 'अपनी कमाई को ट्रैक करें, ऑर्डर पूरे करें और अपने खाते को एक ही स्थान पर प्रबंधित करें। आपकी सफलता की यात्रा यहाँ जारी है!',

  // Dashboard Stats
  stats_available_balance: 'उपलब्ध बैलेंस',
  stats_total_withdrawn: 'कुल निकासी',
  stats_total_deposit: 'कुल जमा',
  stats_pending_orders: 'लंबित ऑर्डर',
  stats_orders_suffix: ' ऑर्डर',
  stats_task_earnings: 'टास्क कमाई',
  stats_lifetime_earning: 'लाइफटाइम कमाई',

  // Orders
  orders_title: 'मेरे ऑर्डर',
  orders_all: 'सभी ऑर्डर',
  orders_pending: 'लंबित',
  orders_completed: 'पूरा हुआ',
  orders_cancelled: 'रद्द',
  orders_order_id: 'ऑर्डर आईडी',
  orders_platform: 'प्लेटफॉर्म',
  orders_amount: 'राशि',
  orders_commission: 'कमीशन',
  orders_status: 'स्थिति',
  orders_date: 'तारीख',
  orders_no_orders: 'कोई ऑर्डर नहीं मिला',

  // Wallet
  wallet_title: 'मेरा वॉलेट',
  wallet_available_balance: 'उपलब्ध बैलेंस',
  wallet_pending_balance: 'लंबित बैलेंस',
  wallet_total_withdrawn: 'कुल निकासी',
  wallet_deposit_now: 'अभी जमा करें',
  wallet_withdraw_now: 'अभी निकालें',
  wallet_transaction_history: 'लेनदेन का इतिहास',
  wallet_deposit_history: 'जमा इतिहास',
  wallet_withdrawal_history: 'निकासी इतिहास',
  wallet_deposit_desc: "उपलब्ध भुगतान विधियों का उपयोग करके अपने वॉलेट में पैसे जोड़ें।",
  wallet_no_deposits: "कोई जमा नहीं मिला।",
  wallet_withdraw_history: "निकासी इतिहास",
  wallet_withdraw_desc: "अपने वॉलेट से पैसे निकालें।",
  wallet_no_withdrawals: "कोई निकासी नहीं मिली।",
  wallet_no_withdrawals_desc: "आपने अभी तक कोई निकासी नहीं की है।",

  // Analytics
  analytics_title: 'एनालिटिक्स',
  analytics_earnings_overview: 'कमाई का अवलोकन',
  analytics_platform_breakdown: 'प्लेटफॉर्म विवरण',
  analytics_performance_metrics: 'प्रदर्शन मेट्रिक्स',
  analytics_top_products: 'शीर्ष उत्पाद',
  analytics_this_month: 'इस महीने',
  analytics_last_month: 'पिछले महीने',
  analytics_total_revenue: 'कुल राजस्व',
  analytics_avg_order_value: 'औसत ऑर्डर मूल्य',

  // Referral
  referral_title: 'रेफरल प्रोग्राम',
  referral_your_code: 'आपका रेफरल कोड',
  referral_copy_code: 'कोड कॉपी करें',
  referral_share_link: 'लिंक साझा करें',
  referral_total_referrals: 'कुल रेफरल',
  referral_active_referrals: 'सक्रिय रेफरल',
  referral_referral_earnings: 'रेफरल कमाई',
  referral_invite_friends: 'दोस्तों को आमंत्रित करें',

  // Account
  account_title: 'खाता सेटिंग्स',
  account_profile: 'प्रोफ़ाइल',
  account_security: 'सुरक्षा',
  account_notifications: 'सूचनाएं',
  account_kyc: 'केवाईसी सत्यापन',
  account_phone: 'फ़ोन नंबर',
  account_two_factor: 'दो-चरणीय प्रमाणीकरण',
  account_save_changes: 'परिवर्तन सहेजें',
  account_cancel: 'रद्द करें',

  // Auth & Common
  auth_email: 'ईमेल',
  auth_password: 'पासवर्ड',
  auth_confirm_password: 'पासवर्ड की पुष्टि करें',
  auth_forgot_password: 'पासवर्ड भूल गए?',
  auth_remember_me: 'मुझे याद रखें',
  auth_login_button: 'लॉगिन',
  auth_signup_button: 'साइन अप',
  auth_already_have_account: 'पहले से ही खाता है?',
  auth_dont_have_account: "खाता नहीं है?",
  auth_reset_password: 'पासवर्ड रीसेट करें',
  auth_verify_email: 'ईमेल सत्यापित करें',
  auth_live_platform: 'लाइव प्लेटफॉर्म',
  auth_security_verification: 'सुरक्षा सत्यापन',
  auth_captcha_refresh: 'रीफ्रेश',
  auth_captcha_placeholder: 'परिणाम',
  auth_captcha_error: 'गलत जोड़, कृपया पुनः प्रयास करें',
  auth_branding_title: 'प्रचार को बदलें',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'वास्तविक आय में',
  auth_branding_desc: 'दुनिया भर के शीर्ष ई-कॉमर्स ब्रांडों से दैनिक कमीशन कमाने वाले हजारों प्रचारकों में शामिल हों।',
  auth_sign_in_to_account: 'अपने {{system_name}} खाते में साइन इन करें',
  auth_email_placeholder: 'you@example.com',
  auth_password_placeholder: 'अपना पासवर्ड डालें',
  auth_signing_in: 'साइन इन हो रहा है...',
  auth_free_to_join: 'शामिल होना मुफ्त है',
  auth_signup_branding_title: 'कमाना शुरू करें',
  auth_signup_branding_highlight: 'पहले दिन से',
  auth_signup_branding_desc: 'किसी अनुभव की आवश्यकता नहीं है। 2 मिनट में साइन अप करें और शीर्ष ई-कॉमर्स ब्रांडों के लिए कार्य पूरा करना शुरू करें।',
  auth_how_it_works: 'यह कैसे काम करता है',
  auth_signup_desc: '{{system_name}} से जुड़ें और आज ही कमीशन कमाना शुरू करें — यह मुफ़्त है!',
  auth_step_1: 'अपना मुफ्त खाता बनाएं',
  auth_step_2: 'कार्य ब्राउज़ करें और स्वीकार करें',
  auth_step_3: 'पूरा करें और कमीशन कमाएं',
  auth_signup_step_1_title: 'खाता बनाएं',
  auth_signup_step_1_desc: 'अपनी यात्रा शुरू करें',
  auth_signup_step_2_title: 'कार्य पूरा करें',
  auth_signup_step_2_desc: 'दैनिक कमीशन कमाएं',
  auth_signup_step_3_title: 'धन की निकासी',
  auth_signup_step_3_desc: 'तेज़ और सुरक्षित भुगतान',
  auth_benefit_1_title: 'सुरक्षित और विश्वसनीय',
  auth_benefit_1_desc: 'आपकी कमाई के लिए बैंक-स्तरीय सुरक्षा',
  auth_benefit_2_title: 'त्वरित भुगतान',
  auth_benefit_2_desc: '24 घंटे के भीतर कमाई निकालें',
  auth_benefit_3_title: 'वैश्विक समुदाय',
  auth_benefit_3_desc: '12,000+ सक्रिय प्रचारकों से जुड़ें',
  auth_benefit_4_title: '24/7 सहायता',
  auth_benefit_4_desc: 'जब भी आपको आवश्यकता हो सहायता प्राप्त करें',
  auth_strength_weak: 'कमजोर',
  auth_strength_fair: 'ठीक',
  auth_strength_good: 'अच्छा',
  auth_strength_strong: 'मजबूत',
  auth_password_strength: 'पासवर्ड की शक्ति: {{strength}}',
  auth_social_proof: '{{count}}+ कमाने वालों में शामिल हों',
  auth_passwords_match: 'पासवर्ड मेल खाते हैं',
  auth_creating_account: 'खाता बनाया जा रहा है...',
  auth_phone_number: 'फ़ोन नंबर',
  auth_phone_optional: '(वैकल्पिक)',
  auth_phone_placeholder: 'आपका फ़ोन नंबर',
  auth_full_name: 'पूरा नाम',
  auth_full_name_placeholder: 'जॉन डो',
  auth_password_min_chars: 'कम से कम 8 अक्षर',
  auth_confirm_password_placeholder: 'अपना पासवर्ड दोहराएं',
  auth_agree_to: 'मैं सहमत हूँ',
  auth_terms_of_service: 'सेवा की शर्तें',
  auth_privacy_policy: 'गोपनीयता नीति',
  auth_and: 'और',
  auth_create_free_account: 'मुफ्त खाता बनाएं',

  common_loading: 'लोड हो रहा है...',
  common_save: 'सहेजें',
  common_cancel: 'रद्द करें',
  common_delete: 'हटाएं',
  common_edit: 'संपादित करें',
  common_view: 'देखें',
  common_search: 'खोजें',
  common_filter: 'फिल्टर',
  common_export: 'निर्यात',
  common_import: 'आयात',
  common_submit: 'जमा करें',
  common_close: 'बंद करें',
  common_confirm: 'पुष्टि करें',
  common_success: 'सफलता',
  common_error: 'त्रुटि',
  common_warning: 'चेतावनी',
  common_announcement: 'घोषणा',

  val_full_name_required: 'पूरा नाम आवश्यक है',
  val_email_required: 'ईमेल आवश्यक है',
  val_password_required: 'पासवर्ड आवश्यक है',
  val_password_min: 'पासवर्ड कम से कम 8 अक्षर का होना चाहिए',
  val_passwords_dont_match: 'पासवर्ड मेल नहीं खाते',
  val_agree_terms: 'आपको शर्तों से सहमत होना होगा',
  val_conn_error: 'कनेक्शन त्रुटि। कृपया पुनः प्रयास करें।',

  // Homepage
  home_hero_title: 'शीर्ष ई-कॉमर्स प्लेटफॉर्म से कमीशन कमाएं',
  home_hero_subtitle: 'Walmart, Alibaba और AliExpress से दैनिक कमीशन कमाने वाले हजारों उपयोगकर्ताओं में शामिल हों',
  home_get_started: 'अभी शुरू करें',
  home_learn_more: 'अधिक जानें',
  home_how_it_works: 'यह कैसे काम करता है',
  home_features: 'विशेषताएं',
  home_why_choose_us: 'हमें क्यों चुनें',
  home_features_title: 'शक्तिशाली विशेषताएं',
  home_features_subtitle: 'ऑनलाइन कमाई शुरू करने के लिए आपको जो कुछ भी चाहिए। आपकी सफलता को ध्यान में रखकर बनाया गया है।',
  home_commission_tiers: 'कमिशन टियर्स',
  home_testimonials: 'हमारे उपयोगकर्ता क्या कहते हैं',
  home_faq: 'अक्सर पूछे जाने वाले प्रश्न',
  home_cta_title: 'कमाना शुरू करने के लिए तैयार हैं?',
  home_cta_subtitle: 'आज ही हमारे समुदाय में शामिल हों और कमीशन कमाना शुरू करें',
  home_trusted_partner: 'विश्वसनीय भागीदार प्लेटफॉर्म',
  home_secure_platform: 'सुरक्षित प्लेटफॉर्म',
  home_instant_payouts: 'त्वरित भुगतान',
  home_active_users: 'सक्रिय उपयोगकर्ता',
  home_paid_out: 'भुगतान किया गया',
  home_total_paid_out: 'कुल भुगतान',
  home_user_rating: 'उपयोगकर्ता रेटिंग',
  home_countries: 'देश',
  home_commission_badge: 'कमाई की क्षमता',
  home_commission_title: 'कमीशन दरें',
  home_commission_desc: 'उच्च बैलेंस बेहतर कमीशन दरों को अनलॉक करता है। प्रत्येक सत्र में ठीक 25 ऑर्डर दिए जाते हैं - अधिकतम कमाई के लिए प्रतिदिन 4 सत्र तक पूरे करें।',
  home_tier_popular: 'सबसे लोकप्रिय',
  home_tier_commission_per_order: 'प्रति ऑर्डर कमीशन',
  home_tier_earn_examples: 'कमाई के उदाहरण:',
  home_tier_order: 'ऑर्डर',
  home_tier_batch_earn: '25 ऑर्डर/बैच की कमाई:',
  home_tier_daily_potential: 'दैनिक क्षमता (4 बैच × 25 ऑर्डर)',
  home_tier_max_daily: 'प्रतिदिन 100 ऑर्डर तक',
  home_tier_benefit_1: '25 ऑर्डर प्रति बैच',
  home_tier_benefit_2: 'प्रतिदिन अधिकतम 4 बैच',
  home_tier_benefit_3: 'त्वरित कमीशन क्रेडिट',
  home_tier_above: 'ऊपर',
  home_tier_no_tiers: 'कोई कमीशन टियर नहीं मिला।',

  // Comparison Section
  home_compare_badge: 'अंतर',
  home_compare_title: 'हम बेहतर क्यों हैं',
  home_compare_subtitle: 'हमारे प्लेटफॉर्म की तुलना पारंपरिक अंशकालिक नौकरियों से करें और देखें कि हजारों लोग हमें क्यों चुनते हैं।',
  home_compare_feature: 'विशेषता',
  home_compare_traditional: 'पारंपरिक नौकरियां',
  home_compare_our_platform: 'हमारा प्लेटफॉर्म',
  home_compare_f1: 'लचीलापन',
  home_compare_f1_trad: 'निश्चित समय सारिणी',
  home_compare_f1_our: 'कभी भी, कहीं भी काम करें',
  home_compare_f2: 'भुगतान',
  home_compare_f2_trad: 'मासिक या द्वि-साप्ताहिक',
  home_compare_f2_our: 'त्वरित / उसी दिन',
  home_compare_f3: 'आवश्यकताएं',
  home_compare_f3_trad: 'अनुभव/सीवी/साक्षात्कार',
  home_compare_f3_our: 'कोई नहीं - बस एक स्मार्टफोन',
  home_compare_f4: 'विकास',
  home_compare_f4_trad: 'निश्चित वार्षिक वृद्धि',
  home_compare_f4_our: 'अनकैप्ड टियर-आधारित विकास',

  // Testimonials
  home_testi_badge: 'सफलता की कहानियां',
  home_testi_title: 'हजारों द्वारा विश्वसनीय',
  home_testi_subtitle: 'हमारे प्रचारकों के वैश्विक समुदाय से सुनें जिन्होंने अपनी आय को बदल दिया है।',
  home_testi_no_stories: 'अभी तक कोई सफलता की कहानी उपलब्ध नहीं है।',
  home_testi_total_earned: 'कुल कमाई',
  home_testi_time_period: 'समय अवधि',
  home_testi_verified: 'सत्यापित उपयोगकर्ता',
  home_testi_avg_rating: 'औसत रेटिंग',
  home_testi_satisfaction_rate: 'संतुष्टि दर',
  home_testi_support_available: 'सहायता उपलब्ध',

  // FAQ
  home_faq_badge: 'सहायता',
  home_faq_title: 'सामान्य प्रश्न',
  home_faq_subtitle: 'शुरुआत करने और कमाने के बारे में आपको जो कुछ भी जानने की जरूरत है।',
  home_faq_no_data: 'कोई प्रश्न नहीं मिला।',

  // Trust Bar
  home_trust_badge: 'वैश्विक विश्वास',
  home_trust_title: 'प्रमुख ब्रांडों द्वारा विश्वसनीय',
  home_trust_desc: 'हम सत्यापित प्रचार सेवाएं प्रदान करने के लिए दुनिया के सबसे बड़े ई-कॉमर्स प्लेटफॉर्म के साथ साझेदारी करते हैं।',

  // Feature Section
  feature_1_title: 'त्वरित भुगतान',
  feature_1_desc: 'ऑर्डर पूरा होने के तुरंत बाद अपनी कमाई क्रेडिट प्राप्त करें। बिना किसी देरी के कभी भी निकालें।',
  feature_1_detail_1: 'रीयल-टाइम कमीशन क्रेडिट',
  feature_1_detail_2: 'एकाधिक निकासी विकल्प',
  feature_1_detail_3: 'कोई न्यूनतम सीमा नहीं',
  feature_2_title: 'सुरक्षित प्लेटफॉर्म',
  feature_2_desc: 'बैंक-स्तरीय एन्क्रिप्शन आपके डेटा और कमाई की सुरक्षा करता है। दुनिया भर में हजारों उपयोगकर्ताओं द्वारा विश्वसनीय।',
  feature_2_detail_1: 'SSL एन्क्रिप्शन सक्षम',
  feature_2_detail_2: 'दो-चरणीय प्रमाणीकरण',
  feature_2_detail_3: 'नियमित सुरक्षा ऑडिट',
  feature_2_detail_4: 'डेटा गोपनीयता की गारंटी',
  feature_3_title: 'लचीले घंटे',
  feature_3_desc: 'जब चाहें, जहाँ चाहें काम करें। बिना किसी निश्चित समय सारिणी के अपनी गति से ऑर्डर पूरे करें।',
  feature_3_detail_1: 'कोई निश्चित कार्य घंटे नहीं',
  feature_3_detail_2: 'कहीं से भी काम करें',
  feature_3_detail_3: 'अपनी गति चुनें',
  feature_3_detail_4: 'सप्ताहांत उपलब्धता',
  feature_4_title: 'प्रगतिशील कमाई',
  feature_4_desc: 'जैसे-जैसे आप अधिक ऑर्डर पूरे करते हैं, उच्च कमीशन दरें अनलॉक करें। प्रत्येक टियर अपग्रेड के साथ अपनी आय बढ़ाएं।',
  feature_4_detail_1: 'टियर-आधारित कमीशन दरें',
  feature_4_detail_2: 'स्वचालित टियर अपग्रेड',
  feature_4_detail_3: 'प्रदर्शन पुरस्कार',
  feature_5_title: 'वैश्विक प्लेटफॉर्म',
  feature_5_desc: 'दुनिया में कहीं से भी अंतरराष्ट्रीय ब्रांडों के साथ काम करें। बहु-मुद्रा समर्थन शामिल है।',
  feature_5_detail_1: 'दुनिया भर में उपलब्ध',
  feature_5_detail_2: 'बहु-मुद्रा समर्थन',
  feature_5_detail_3: 'स्थानीय भुगतान विधियां',
  feature_6_title: '24/7 सहायता',
  feature_6_desc: 'हमारी समर्पित सहायता टीम हमेशा मदद के लिए तैयार है। लाइव चैट, ईमेल या फोन के माध्यम से सहायता प्राप्त करें।',
  feature_6_detail_1: 'लाइव चैट उपलब्ध',
  feature_6_detail_2: '24/7 ईमेल सहायता',
  feature_6_detail_3: 'फोन सहायता',
  feature_6_detail_4: 'विस्तृत अक्सर पूछे जाने वाले प्रश्न',
  feature_7_title: 'रेफरल प्रोग्राम',
  feature_7_desc: 'दोस्तों को आमंत्रित करके अतिरिक्त आय अर्जित करें। अपने रेफरल की कमाई से लाइफटाइम कमीशन प्राप्त करें।',
  feature_7_detail_1: 'लाइफटाइम रेफरल कमाई',
  feature_7_detail_2: 'असीमित रेफरल',
  feature_7_detail_3: 'आसान शेयरिंग टूल्स',
  feature_7_detail_4: 'बोनस प्रोत्साहन',
  feature_8_title: 'बहु-मुद्रा',
  feature_8_desc: 'प्रमुख मुद्राओं और भुगतान विधियों के लिए समर्थन। वह चुनें जो आपके लिए सबसे अच्छा काम करता है।',
  feature_8_detail_1: 'USD, EUR, GBP समर्थन',
  feature_8_detail_2: 'बैंक हस्तांतरण उपलब्ध',
  feature_8_detail_3: 'ई-वॉलेट एकीकरण',
  feature_8_detail_4: 'क्रिप्टो विकल्प जल्द ही आ रहे हैं',
  feature_9_title: 'त्वरित सूचनाएं',
  feature_9_desc: 'नए ऑर्डर, कमाई और खाता गतिविधियों के लिए रियल-टाइम अलर्ट के साथ अपडेट रहें।',
  feature_9_detail_1: 'पुश सूचनाएं',
  feature_9_detail_2: 'ईमेल अलर्ट',
  feature_9_detail_3: 'एसएमएस अपडेट',
  feature_9_detail_4: 'इन-ऐप संदेश',

  // Home Page Additional Sections
  home_how_it_works_badge: 'सरल प्रक्रिया',
  home_how_it_works_title: 'यह कैसे काम करता है',
  home_how_it_works_subtitle: '4 सरल चरणों में कमाना शुरू करें। किसी अनुभव की आवश्यकता नहीं है, बस प्रक्रिया का पालन करें और अपनी कमाई को बढ़ते हुए देखें।',
  home_cta_ready_title: 'अपनी यात्रा शुरू करने के लिए तैयार हैं?',
  home_cta_ready_desc: 'हजारों उपयोगकर्ताओं में शामिल हों जो पहले से ही दैनिक कमाई कर रहे हैं। आपका पहला कमीशन बस कुछ ही मिनटों की दूरी पर है!',
  home_cta_avg_time: 'पहली कमाई के लिए औसत समय:',
  home_cta_15_mins: '15 मिनट',
  home_cta_new_users: 'आज नए उपयोगकर्ता:',

  // CTA Section (Premium)
  home_cta_limit_spots: 'इस महीने सीमित स्थान उपलब्ध हैं',
  home_cta_main_title: 'पैसे कमाना शुरू करें',
  home_cta_today: 'आज ही!',
  home_cta_main_desc: 'दैनिक कमीशन कमाने वाले हजारों उपयोगकर्ताओं में शामिल हों। किसी अनुभव की आवश्यकता नहीं, लचीले घंटे, त्वरित भुगतान। आपकी वित्तीय स्वतंत्रता यहाँ से शुरू होती है।',
  home_cta_spots_remaining: 'शेष स्थान',
  home_cta_new_users_today: 'आज नए उपयोगकर्ता',
  home_cta_create_account: 'मुफ्त खाता बनाएं',
  home_cta_sign_in: 'साइन इन करें',
  home_cta_secure: '100% सुरक्षित',
  home_cta_payouts: '24-48घंटे में भुगतान',
  home_cta_rating: '4.9/5 रेटिंग',
  home_cta_active_users: 'सक्रिय उपयोगकर्ता',
  home_cta_total_paid: 'कुल भुगतान',
  home_cta_orders_done: 'पूर्ण किए गए कार्य',
  home_cta_satisfaction: 'संतुष्टि',
  home_cta_guarantee_title: 'पैसे वापस करने की गारंटी',
  home_cta_guarantee_desc: 'संतुष्ट नहीं हैं? 7 दिनों के भीतर अपना जमा वापस पाएं',

  // Footer Branding & Extras
  footer_brand_desc: 'दुनिया का अग्रणी ई-कॉमर्स प्रचार प्लेटफॉर्म। आज ही हमारे प्रचारकों के वैश्विक नेटवर्क में शामिल हों और शीर्ष ब्रांडों से कमीशन कमाना शुरू करें।',
  footer_ssl_secure: 'SSL सुरक्षित',
  footer_aes_256: 'AES-256 एन्क्रिप्शन',
  footer_cookie_policy: 'कुकी नीति',
  footer_disclaimer: 'अस्वीकरण',
  footer_all_rights: 'सर्वाधिकार सुरक्षित।',

  // Announcements
  announcement_withdrawal_delay_title: 'निकासी प्रसंस्करण में देरी',
  announcement_withdrawal_delay_summary: 'अधिक मात्रा के कारण निकासी में 72 घंटे तक का समय लग सकता है। कृपया तदनुसार योजना बनाएं।',
  announcement_date_june_14: '14 जून, 2025',

  // How It Works Steps
  step_1_title: 'साइन अप करें',
  step_1_desc: 'अपना खाता बनाने में 2 मिनट से भी कम समय लगता है।',
  step_1_detail_1: 'अपनी बुनियादी जानकारी दर्ज करें',
  step_1_detail_2: 'अपना ईमेल पता सत्यापित करें',
  step_1_detail_3: 'अपने खाते को सुरक्षित करें',
  step_1_detail_4: 'डैशबोर्ड तक त्वरित पहुँच',
  step_2_title: 'कार्य चुनें',
  step_2_desc: 'उपलब्ध प्रचार कार्यों में से चुनें।',
  step_2_detail_1: 'प्लेटफॉर्म के आधार पर फिल्टर करें',
  step_2_detail_2: 'कमीशन दरें देखें',
  step_2_detail_3: 'एकाधिक कार्यों को स्वीकार करें',
  step_2_detail_4: 'रीयल-टाइम टास्क अपडेट',
  step_3_title: 'कार्य पूरा करें',
  step_3_desc: 'निर्देशों के अनुसार कार्यों को पूरा करें।',
  step_3_detail_1: 'पालन करने में आसान निर्देश',
  step_3_detail_2: 'त्वरित कार्य सबमिशन',
  step_3_detail_3: 'स्वचालित审核 सत्यापन',
  step_3_detail_4: 'मोबाइल के अनुकूल इंटरफ़ेस',
  step_4_title: 'कमाएँ और निकालें',
  step_4_desc: 'प्रत्येक पूर्ण कार्य के लिए भुगतान प्राप्त करें।',
  step_4_detail_1: 'रीयल-टाइम कमाई ट्रैकिंग',
  step_4_detail_2: 'बहुत कम निकासी सीमा',
  step_4_detail_3: 'एकाधिक भुगतान विधियां',
  step_4_detail_4: '24/7 निकासी सहायता',

  // Redesigned Footer
  footer_stay_loop_title: 'जुड़े रहें',
  footer_stay_loop_desc: 'नवीनतम अपडेट, टिप्स और विशेष ऑफ़र सीधे अपने इनबॉक्स में प्राप्त करें।',
  footer_subscribe: 'सब्सक्राइब करें',
  footer_subscribe_placeholder: 'अपना ईमेल पता दर्ज करें',
  footer_trusted_secure: 'भरोसेमंद और सुरक्षित:',
  footer_ssl_secured: 'SSL सुरक्षित',
  footer_ssl_secured_desc: '256-बिट SSL',
  footer_aes_encryption: 'AES-256 एन्क्रिप्शन',
  footer_aes_encryption_desc: 'बैंक-ग्रेड',
  footer_kyc_compliant: 'KYC अनुपालन',
  footer_kyc_compliant_desc: 'सत्यापित',
  footer_gdpr_compliant: 'GDPR अनुपालन',
  footer_gdpr_compliant_desc: 'डेटा सुरक्षित',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'प्रमाणित',
  footer_platform: 'प्लेटफॉर्म',
  footer_support: 'सहायता',
  footer_legal: 'कानूनी',
  footer_help_center: 'सहायता केंद्र',
  footer_contact_us: 'संपर्क करें',
  footer_payments_label: 'भुगतान:',
  home_live_activity_title: 'लाइव प्लेटफॉर्म गतिविधि',
  home_recent_activity_title: 'हाल की गतिविधि',
  home_total_commissions_paid: 'कुल भुगतान किया गया कमीशन',
  home_active_users_online: 'ऑनलाइन सक्रिय उपयोगकर्ता',
  home_tasks_completed_today: 'आज पूरे किए गए कार्य',
};